import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { ItemNotificationComponent } from '../../components/item-notification/item-notification.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Session from '../../utils/session.service';
import Config from '../../utils/config.service';
import RestService from '../../services/core-rest.service';
import Toast from '../../services/toast.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import { PanelDirective } from '../../directives/panel.directive';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'table-insurance-policies',
	templateUrl: './table-insurance-policies.component.html',
	imports: [
		CommonModule, PanelDirective, DatePipe, ArrayLimitToPipe, StartFromPipe, 
		TranslatePipe, ItemNoContentComponent, LoaderOverlayComponent, 
		ItemNotificationComponent, FormsModule
	]
})
export class TableInsurancePoliciesComponent implements OnInit, OnDestroy {
	private session: Session = inject(Session);
	private config: Config = inject(Config);
	private restService: RestService = inject(RestService);
	private toast: Toast = inject(Toast);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() insurancePolicies: any;
	@Output() insurancePoliciesChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() pageSize: any | undefined;
	@Input() currentPage: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.filter = {
			orderBy: 'unknown',
			ascending: false
		};
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.insurancePolicies = [];
		this.vm.loading = true;
		
		this.loadInsurancePolicies(true, true);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, "loadMorePages", () => {
				if (!this.vm.endReached) {
					this.loadInsurancePolicies();
				}
			})
		);
		
		var user: any = this.session.getSession().user;
		this.vm.userLanguage = user.deviceLanguage;
		
		this.vm.loadInsurancePolicies = this.loadInsurancePolicies;
		this.vm.getPolicyDownloadUrl = this.getPolicyDownloadUrl;
		this.vm.setFilter = this.setFilter;
		this.vm.getCovers = this.getCovers;
		this.vm.editPolicy = this.editPolicy;
		this.vm.getCoverLimit = this.getCoverLimit;
		this.vm.getCoverDeductible = this.getCoverDeductible;
		this.vm.getCoverCoverageRate = this.getCoverCoverageRate;
		this.vm.getCoverExtra = this.getCoverExtra;
		this.vm.getCoverTitle = this.getCoverTitle;
		this.vm.getCoverDescription = this.getCoverDescription;
		this.vm.getContactUsInfo = this.getContactUsInfo;
		this.vm.getInvoiceNeededByEmployerInfo = this.getInvoiceNeededByEmployerInfo;
		this.vm.getPreAuthorizationRequiredInfo = this.getPreAuthorizationRequiredInfo;
		this.vm.getInsurerName = this.getInsurerName;
		this.vm.canEditPolicy = this.canEditPolicy;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	loadInsurancePolicies(isInitial?, hasLoader?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		var params: any = {
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.insurancePolicies) ? this.vm.insurancePolicies.length : 0
		};
		if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 2) params.name = this.vm.term.trim();
		
		this.restService.getUserPolicyList(params)
			.then((insurancePolicies) => {
				if (insurancePolicies && insurancePolicies.length < this.vm.pageSize * 2) {
					this.vm.endReached = true;
				}
				if (isInitial) this.vm.currentPage = 0;
				if (hasLoader) {
					this.angularHelperService.createTimer(() => {
						this.vm.loading = false;
						this.vm.insurancePolicies = isInitial ? insurancePolicies : this.vm.insurancePolicies.concat(insurancePolicies);
						this.insurancePoliciesChange.emit(this.vm.insurancePolicies);
					}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
				} else {
					this.vm.insurancePolicies = isInitial ? insurancePolicies : this.vm.insurancePolicies.concat(insurancePolicies);
					this.insurancePoliciesChange.emit(this.vm.insurancePolicies);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	canEditPolicy(policy) {
		var isUserSettingsRequired: any = !!(policy['purchasedPackage']['userSettingsRequired']);
		var isBankAccountRequired: any = !!(policy['purchasedPackage']['policyUserBankAccountRequired']);
		
		return isUserSettingsRequired || isBankAccountRequired;
	}
	
	editPolicy(policy) {
		var isUserSettingsRequired: any = !!(policy['purchasedPackage']['userSettingsRequired']);
		var isBankAccountRequired: any = !!(policy['purchasedPackage']['policyUserBankAccountRequired']);
		var isHealthQuestionnaireRequired: any = !!(policy['questionnaireRequired']);
		var healthQuestionnaireId: any = isHealthQuestionnaireRequired ? policy['purchasedPackage']['healthQuestionnaire']['id'] : 0;
		
		var queryParams = {};
		queryParams['mode'] = 'edit';
		queryParams['policyUserId'] = policy.policyUserId;
		queryParams['userSettingsRequired'] = isUserSettingsRequired ? 'yes' : 'no';
		queryParams['bankAccountRequired'] = isBankAccountRequired ? 'yes' : 'no';
		// queryParams['questionnaireRequired'] = isHealthQuestionnaireRequired ? 'yes' : 'no';
		// if (isHealthQuestionnaireRequired) queryParams['questionnaireId'] = healthQuestionnaireId;
		queryParams['questionnaireRequired'] = 'no';
		this.angularRoutingHelperService.setPath("/policy-settings", false, false, queryParams);
	}
	
	getInsurerName(insurancePolicy) {
		if (!insurancePolicy || !insurancePolicy.purchasedPackage) {
			return '';
		}
		
		if (insurancePolicy.purchasedPackage.insurerName) {
			var insurer: any = '(' + insurancePolicy.purchasedPackage.insurerName;
			if (insurancePolicy.purchasedPackage.actualInsuranceProvider) {
				insurer += '/' + insurancePolicy.purchasedPackage.actualInsuranceProvider;
			}
			insurer += ')';
			return insurer;
		} else if (insurancePolicy.purchasedPackage.actualInsuranceProvider) {
			return '(' + insurancePolicy.purchasedPackage.actualInsuranceProvider + ')';
		} else {
			return '';
		}
	}
	
	getCovers(policy) {
		if (policy.covers && policy.covers.length > 0) {
			return;
		}
		this.restService.getUserPolicyDetails({ policyId: policy.id })
			.then((res) => {
				policy.covers = res;
			})
			.catch((err) => {
				this.toast.showWithTranslation('Insurance.Policy.Details_Failed');
			});
	}
	
	getCoverLimit(cover) {
		if (cover.coverLimitAmountPerUser) {
			return cover.coverLimitAmountPerUser + (cover.currency ? cover.currency : '€');
		} else if (cover.coverLimitAmountPerEmployee) {
			return cover.coverLimitAmountPerEmployee + (cover.currency ? cover.currency : '€');
		} else if (cover.exclusion) {
			return '🗴';
		} else if (!this.getCoverExtra(cover) && !this.getCoverDeductible(cover) && !this.getCoverCoverageRate(cover)) {
			cover.inclusion = true;
			return '✔';
		}
		return false;
	}
	
	getCoverExtra(cover) {
		var result: any = '';
		if (cover.extraConditions) {
			result += cover.extraConditions + '\n';
		}
		if (cover.coverLimitAmountTotal) {
			result += cover.coverLimitAmountTotal + (cover.currency ? cover.currency : '€') + '\n';
		}
		if (cover.amountCovered) {
			result += cover.amountCovered + ' ' + cover.amountUnit + '\n';
		}
		if (cover.amountCostLimitPerUnit) {
			result += cover.amountCostLimitPerUnit + (cover.currency ? cover.currency : '€') + '\n';
		}
		return result;
	}
	
	getCoverDeductible(cover) {
		if (cover.deductibleAmount) {
			return cover.deductibleAmount + (cover.currency ? cover.currency : '€');
		} else if (cover.deductiblePercentage) {
			return cover.deductiblePercentage + '%';
		} else {
			return '';
		}
	}
	
	getCoverCoverageRate(cover) {
		if (cover.coverageRate) {
			return cover.coverageRate + '%';
		} else {
			return '';
		}
	}
	
	getCoverTitle(cover) {
		if (cover.translations && this.vm.userLanguage) {
			for (var i = 0; i < cover.translations.length; i++) {
				if (cover.translations[i].language == this.vm.userLanguage) {
					return cover.translations[i].title;
				}
			}
		}
		return cover.title;
	}
	
	getCoverDescription(cover) {
		if (cover.translations && this.vm.userLanguage) {
			for (var i = 0; i < cover.translations.length; i++) {
				if (cover.translations[i].language == this.vm.userLanguage) {
					return cover.translations[i].description;
				}
			}
		}
		return cover.description;
	}
	
	getContactUsInfo(policy) {
		if (policy && policy.insuranceContact) {
			var contactUs: any = '';
			if (policy.insuranceContact.email
			&& policy.insuranceContact.phone) {
				contactUs = this.angularFilterHelperService.translate('Claim_Request.Contact_Us_Phone_Or_Email');
			} else if (policy.insuranceContact.email) {
				contactUs = this.angularFilterHelperService.translate('Claim_Request.Contact_Us_Email_Only');
			} else if (policy.insuranceContact.phone) {
				contactUs = this.angularFilterHelperService.translate('Claim_Request.Contact_Us_Phone_Only');
			}
			if (policy.insuranceContact.startTime) {
				contactUs = contactUs.replace('%s$1', policy.insuranceContact.startTime);
			} else {
				contactUs = contactUs.replace('%s$1', '00:00');
			}
			if (policy.insuranceContact.endTime) {
				contactUs = contactUs.replace('%s$2', policy.insuranceContact.endTime);
			} else {
				contactUs = contactUs.replace('%s$2', '24:00');
			}
			if (policy.insuranceContact.phone) {
				contactUs = contactUs.replace('%s$3', policy.insuranceContact.phone);
			}
			if (policy.insuranceContact.email) {
				contactUs = contactUs.replace('%s$4', policy.insuranceContact.email);
			}
			return contactUs;
		} else {
			return '';
		}
	}
	
	getInvoiceNeededByEmployerInfo() {
		return this.angularFilterHelperService.translate('Insurance.Policy.InvoiceNeededByEmployer');
	}
	
	getPreAuthorizationRequiredInfo(cover) {
		if (cover.preAuthorizationUrl) {
			return this.angularFilterHelperService.translate('Insurance.Policy.PreAuthorizationRequiredWithLink')
				.replace('%s', cover.preAuthorizationUrl);
		} else {
			return this.angularFilterHelperService.translate('Insurance.Policy.PreAuthorizationRequired');
		}
	}
	
	setFilter(name) {
		// Temporarily disabled
		// this.vm.filter = this.vm.filter || {};
		// this.vm.filter.ascending = this.vm.filter.orderBy === name ? !this.vm.filter.ascending : false;
		// this.vm.filter.orderBy = name;
		//
		// this.loadInsurancePolicies(true);
	}
	
	getPolicyDownloadUrl(insurancePolicy) {
		return this.config.getRestUrl() + 'insurance/api/v1/policy/' + insurancePolicy['id'] + '/' + insurancePolicy['policyNumber'] + '.pdf';
	}
	
}